<template>
  <div>
    <div class="info_configuration">
      Your gateway configuration file
    </div>
    <div class="configuration">
      <div class="config_text">{{conf}}</div>
    </div>
    <div class="download" @click="download('config.yaml',conf)">
      download
    </div>
  </div>
</template>

<script>
  import GateWay from '../../../../Class/GateWay'

  export default {
    name: "gateway_configuration",
    props: {
      conf: {
        type: String,
        required: true
      }
    },
    data() {
      return {}
    },
    created() {
    }, methods: {
      download(filename, text) {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .configuration {
    //border-style: solid;
    background-color: rgba(225, 225, 225, 1);
    margin: 2%;
    border-width: thin;
    padding-bottom: 1%;
  }

  .config_text {
    font-family: Monospace;
    height: 60%;
    max-height: 500px;
    overflow-y: scroll;
    white-space: pre-wrap;
    //  font-size: 1.3em;
    background-color: transparent;
    color: black;
  }

  .download {
    display: inline-block;
    //  font-size: 1.3em;
    margin: 2%;
    font-weight: bold;
  }

  .download:hover {
    color: blue;
  }

  .download:active {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// src/views/settings/newGateWay/subComponents/gateway_configuration.vue